export const SWIFT_TYPE_URL = process.env.NEXT_PUBLIC_SWIFT_TYPE_URL;
export const SWIFT_TYPE_ENGIN_KEYS = {
  en_US: process.env.NEXT_PUBLIC_SWIFT_TYPE_ENGINE_EN_US,
  en_CA: process.env.NEXT_PUBLIC_SWIFT_TYPE_ENGINE_EN_CA,
  fr_CA: process.env.NEXT_PUBLIC_SWIFT_TYPE_ENGINE_FR_CA,
  es_MX: process.env.NEXT_PUBLIC_SWIFT_TYPE_ENGINE_ES_MX,
  es_419: process.env.NEXT_PUBLIC_SWIFT_TYPE_ENGINE_ES_419,
};
